<script lang="ts" setup>
  import type { CLoadingButtonProps } from './CLoadingButton.types'

  withDefaults(defineProps<CLoadingButtonProps>(), {
    loading: false
  })
</script>

<template>
  <CButton
    :dark-mode="darkMode"
    :disabled="disabled || loading"
    :fluid
    :size
    :tab-index="tabIndex"
    :type
    :variant
    class="c-loading-button"
  >
    <div class="content-wrapper">
      <CLoadingAnimation v-if="loading" variant="light" />
      <slot />
    </div>
  </CButton>
</template>

<style lang="scss" scoped>
  .c-loading-button {
    .content-wrapper {
      display: flex;
      align-items: center;
      gap: 0.625rem;

      margin: auto;
      width: fit-content;
    }
  }
</style>
